// Valvontapäivä (claims supervision deadline). Change it here; every text
// mentioning the date uses this constant via the `date` formatter (see
// i18n/index.ts), which renders it in each language's own format.
export const VALVONTAPAIVA = new Date(2026, 10, 30); // 30.11.2026

// Konkurssipäivä (date of bankruptcy); claim amounts are stated as of this
// date.
export const KONKURSSIPAIVA = new Date(2026, 1, 10); // 10.2.2026
